import React, { useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTiktok,
  faFacebookF,
  faLinkedinIn,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import logoZ from '../assets/images/logos/logoZ.png';
import logoZASFIT from '../assets/images/logos/logoZASFIT.png';   // ⬅️  NUEVO

import './Footer.css';

export default function Footer() {

  const openTidio = useCallback((e) => {
    e.preventDefault();
    const run = () => window.tidioChatApi?.open();
    if (window.tidioChatApi) run();
    else document.addEventListener("tidioChat-ready", run, { once: true });
  }, []);

  return (
    <footer className="footer-area pt-30 pb-20">
      <div className="container">
        <div className="footer-content">
          {/* --- Logo --- */}
          <a href="/" className="logo d-flex flex-column align-items-center gap-1">
            {/* icono redondo “Z” */}
            <img
              src={logoZ}
              alt="Logotipo Zasfit"
              className="footer-logo-icon"
              width="80"
              height="80"
              loading="eager"
            />
            {/* word-mark “ZASFIT” */}
            <img
              src={logoZASFIT}
              alt="ZASFIT"
              className="footer-wordmark"
              width="171"
              height="40"
              loading="eager"
            />
          </a>

          {/* --- Redes sociales --- */}
          <ul className="social-links">
            <li>
              <a
                href="https://instagram.com/zasfit.es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
            <li>
              <a
                href="https://tiktok.com/@zasfit.es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
            </li>
            <li>
              <a
                href="https://facebook.com/zasfit.es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/zasfit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/zasfit_es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
            </li>
          </ul>

          {/* --- Navegación secundaria --- */}
          <ul className="navbar-nav">
          <li className="nav-item">
              <a href="#home" className="nav-link">
                Inicio
              </a>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link">
                Servicios
              </a>
            </li>
            <li className="nav-item">
              <a href="#chat" onClick={openTidio} className="nav-link">
                Soporte
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/privacy"
                target="_blank"                // abre en pestaña nueva
                rel="noopener noreferrer"      // buena práctica de seguridad
                className="nav-link"
              >
                Política de Privacidad
              </a>
            </li>
            {/* <li className="nav-item">
              <a href="/aplicacion-para-entrenadores-personales/" className="nav-link">
                Aplicación para Entrenadores
              </a>
            </li>
            <li className="nav-item">
              <a href="/mejores-apps-entrenadores-personales/" className="nav-link">
                Mejores Apps (2025)
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a href="/faq" className="nav-link">
                FAQ's
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a href="/contact" className="nav-link">
                Contacto
              </a>
            </li> */}
          </ul>

          {/* --- Copyright --- */}
          <p className="copyright">
            Copyright © {new Date().getFullYear()} <strong>Zasfit</strong>. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
